<template>
  <v-row class="align-center justify-center no-gutters">
    <v-col
      :cols="12 / columns"
      v-for="(photo, i) in photos"
      :key="photo.details.photo.image.id"
      class="photo"
      :class="{'pa-1': photos.length > 1}"
      :data-key="photo.details.photo.image.id"
    >
      <v-img
        contain
        width="100%"
        height="100%"
        class="gallery-item"
        :src="`${optimizedImageURL(photo.details.photo.image, {maxWidth})}`"
        :lazy-src="getLazySrc(photo.details.photo.image)"
        :aspect-ratio="getAspectRatio(photo.details.photo.image)"
        :position="imagePosition(i, photo)"
        @click="onPhotoClick(photo)"
        @mouseenter="$emit('mouseenter', photo)"
        @mouseleave="$emit('mouseleave', photo)"
        :style="{cursor: photos.length > 1 ? 'pointer' : null}"
      />
    </v-col>
  </v-row>
</template>

<script>
import { optimizedImageURL, getLazySrc, getAspectRatio } from '@/services/OptimizedImage'

export default {
  name: 'PhotoExhibitionGridElement',
  props: {
    data: {
      type: Object,
      required: true
    },
    position: {
      type: String,
      required: false
    },
    containerColumns: {
      type: Number,
      required: true
    }
  },

  data () {
    return {
      selectedPhoto: null
    }
  },

  computed: {
    columns () {
      return this.photos.length > 1 ? 2 : 1
    },
    maxWidth () {
      const threshold = this.$vuetify.breakpoint.thresholds[this.$vuetify.breakpoint.name]
      return ((threshold || 4096) * this.dpr) / this.containerColumns / this.columns
    },
    dpr () {
      return window.devicePixelRatio
    },
    photos () {
      return this.data.photos
    }
  },

  methods: {
    optimizedImageURL,
    getLazySrc,
    getAspectRatio,
    onPhotoClick (photo) {
      // debugger
      if (this.selectedPhoto === photo) {
        this.selectedPhoto = null
      } else {
        this.selectedPhoto = photo
      }
      this.$emit('click', photo)
    },
    imagePosition (i, photo) {
      // if (this.selectedPhoto === photo) {
      //   return '50% 50%'
      // }
      switch (this.position) {
        case 'right':
          return '100% 50%'
        case 'left':
          return '0% 50%'
        case 'center':
          if (this.photos.length === 1) return '50%, 50%'
          return (i + 1) % 2 === 0 ? '0% 50%' : '100% 50%'
      }
    }
  }
}
</script>

<style lang="scss" scoped>

.col-12 {
  height: 100%;
}

.col-6 {
  height: 50%;
}

::v-deep .v-image__image {
  transition: background-position 0.5s $ease-in-out-quad;
}

.row {
  position: relative;
}

::v-deep .gallery-item {
  .v-image__image {
    transition: transform 1.5s $ease-out-expo;
  }

  &:hover {
    .v-image__image {
      transform: scale(1.1);
    }
  }
}

// .photo {
//   position: relative;
//   z-index: 0;

//   &.selected {
//     position: absolute;
//     z-index: 1;
//     top: 0;
//     left: 0;
//     width: 100%;
//     height: 100%;
//   }
// }

// .element-move {
//   transition: transform 1.5s $ease-in-out-quad;
// }

// .element-leave-active {
//   position: absolute;
// }
// .element-enter-active,
// .element-leave-active {
//   transition: opacity 0.5s;
// }

// .element-enter,
// .element-leave-to {
//   opacity: 0;
// }

</style>
